import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  stepper: {
    padding: `${theme.spacing(2, 0)} !important`,
  },
  stepIconRoot: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px solid ${theme.palette.grey[400]}`,
    color: theme.palette.grey[400],
    fontWeight: 700,
    fontSize: 14,
    backgroundColor: 'transparent',
  },
  stepIconActive: {
    backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.common.white,
  },
  stepIconCompleted: {
    backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.common.white,
  },
  stepLabelActive: {
    fontWeight: '700 !important',
    color: `${theme.palette.primary.main} !important`,
  },
  stepLabelCompleted: {
    fontWeight: '600 !important',
  },
}))

export default useStyles
